import { useEffect, useState } from "react";

const navLinks = [
  { label: "首页", href: "#home" },
  { label: "本命推荐", href: "#recommend" },
  { label: "分类推荐", href: "#category" },
  { label: "入坑指南", href: "#guide" },
  { label: "热门排行", href: "#rank" },
  { label: "常见问题", href: "#faq" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-background-50/95 backdrop-blur border-b border-background-200" : "bg-transparent"
      }`}
    >
      <nav className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-20">
          <a href="#home" className="flex items-center gap-2.5 whitespace-nowrap">
            <span className="w-9 h-9 rounded-xl bg-primary-500 flex items-center justify-center text-background-50">
              <i className="ri-book-2-fill text-lg"></i>
            </span>
            <span className="font-display text-xl md:text-2xl tracking-wide text-foreground-950">
              131漫画网
            </span>
          </a>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="px-3 py-2 rounded-lg text-sm text-foreground-700 hover:text-primary-600 hover:bg-primary-50 transition-colors whitespace-nowrap"
              >
                {link.label}
              </a>
            ))}
          </div>

          <div className="hidden md:block">
            <a
              href="#recommend"
              className="inline-flex items-center gap-1.5 px-4 py-2 rounded-lg bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              <i className="ri-sparkling-2-line"></i>
              开始找本命
            </a>
          </div>

          <button
            onClick={() => setOpen(!open)}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-900 hover:bg-background-200/70 transition-colors"
            aria-label="打开菜单"
          >
            <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-2xl`}></i>
          </button>
        </div>

        {open && (
          <div className="md:hidden pb-4 flex flex-col gap-1">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="px-3 py-2.5 rounded-lg text-sm text-foreground-800 hover:bg-primary-50 hover:text-primary-600 transition-colors"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#recommend"
              onClick={() => setOpen(false)}
              className="mt-2 inline-flex items-center justify-center gap-1.5 px-4 py-2.5 rounded-lg bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              开始找本命
            </a>
          </div>
        )}
      </nav>
    </header>
  );
}